//execute the function when page is ready
 document.addEventListener('DOMContentLoaded', () => {                                
         var h=$("#h").val();
         var m=$("#m").val();
         var s=$("#s").val();
         var d=$("#d").val();
         var month=$("#month").val();
         var ampm=$("#ampm").val();
                                
         var bh=$("#bh").val();
         var bm=$("#bm").val();
         var bs=$("#bs").val();
         var bd=$("#bd").val();
         var bmonth=$("#bmonth").val();
         var bampm=$("#bampm").val();

         var toChangeCount=1;
         var zone=new Date().toTimeString().slice(9);
         console.log("REGION");
         console.log(zone);
		 
         //Mountain Daylight Time IS IN THE CUSTOMS FIELDS 
     
         //PST
         //if(zone == "GMT-0700 (Pacific Daylight Time)"){*/
         //GMT-0700 (Pacific Daylight Time)
     	 //(UTC-08:00)Pacific Time(US & Canada)
         if(zone.match(/GMT-0700/)){
            console.log("pacifico");
            h=parseInt(h)-1;
            bh=parseInt(bh)-1;
         }
         //CT7
         //GMT-0500 (Central Daylight Time)
     	 //(UTC-06:00) Central Time(US & CANADA)
         if(zone.match(/GMT-0500/)){
            console.log("central time");
            h=parseInt(h)+1;
            bh=parseInt(bh)+1;
         }
         //ET
         //GMT-0400 (Eastern Daylight Time)
         //(UTC-05:00) Eastern Time(US & CANADA)
     	 if(zone.match(/GMT-0400/)){
            console.log("Eastern");
            h=parseInt(h)+2;
            bh=parseInt(bh)+2;
         }          

        if(h != 999 && h != 888 ){
      		  const DATE_TARGET = new Date(month+"/"+d+"/"+2021+" "+h+":"+m+" "+ampm);
              const DATE_ENDTARGET = new Date(bmonth+"/"+bd+"/"+2021+" "+bh+":"+bm+" "+bampm);
              const TEST_TARGET = new Date("05/05/2021 11:30:00 PM");
              const SPAN_DAYS = document.querySelector('span#days');
              const SPAN_HOURS = document.querySelector('span#hours');
              const SPAN_MINUTES = document.querySelector('span#minutes');
              const SPAN_SECONDS = document.querySelector('span#seconds');


              const MILLISECONDS_OF_A_SECOND = 1000;
              const MILLISECONDS_OF_A_MINUTE = MILLISECONDS_OF_A_SECOND * 60;
              const MILLISECONDS_OF_A_HOUR = MILLISECONDS_OF_A_MINUTE * 60;
              const MILLISECONDS_OF_A_DAY = MILLISECONDS_OF_A_HOUR * 24

            
              function updateCountdown() { 
                                           
                  let DURATION;
                  const NOW = new Date();

                	//when finalised the first count, start the second count
                   if(toChangeCount == 1){
                         DURATION = DATE_TARGET - NOW;
                    }else{
                      if(toChangeCount == 2){
                        DURATION = DATE_ENDTARGET - NOW;
                      }

                    }
                 
                
                  const DURATIONEND = DATE_ENDTARGET-NOW;
                  const REMAINING_DAYS = Math.floor(DURATION / MILLISECONDS_OF_A_DAY);
                  const REMAINING_HOURS = Math.floor((DURATION % MILLISECONDS_OF_A_DAY) / MILLISECONDS_OF_A_HOUR);
                  const REMAINING_MINUTES = Math.floor((DURATION % MILLISECONDS_OF_A_HOUR) / MILLISECONDS_OF_A_MINUTE);
                  const REMAINING_SECONDS = Math.floor((DURATION % MILLISECONDS_OF_A_MINUTE) / MILLISECONDS_OF_A_SECOND);
                  
                  if(DURATION >= 0 && toChangeCount == 1){
                        // Render
                        toChangeCount = 1;
                    if(REMAINING_DAYS >= 0){//when count continue
                    	SPAN_DAYS.textContent = REMAINING_DAYS;
                        SPAN_HOURS.textContent = REMAINING_HOURS;
                        SPAN_MINUTES.textContent = REMAINING_MINUTES;
                        SPAN_SECONDS.textContent = REMAINING_SECONDS;
                    
                    }else{//when count end for countinue the end count                   
                    	SPAN_DAYS.textContent = 0;
                        SPAN_HOURS.textContent = 0;
                        SPAN_MINUTES.textContent = 0;
                        SPAN_SECONDS.textContent = 0;
                    }
                       
                  }else{
                      toChangeCount = 2;
                      $("#txtTitle").html("End sale in:");
                      document.getElementById("sCode").disabled=false;
                      if(REMAINING_DAYS >= 0){
                    	SPAN_DAYS.textContent = REMAINING_DAYS;
                        SPAN_HOURS.textContent = REMAINING_HOURS;
                        SPAN_MINUTES.textContent = REMAINING_MINUTES;
                        SPAN_SECONDS.textContent = REMAINING_SECONDS;
                    }else{
                    	SPAN_DAYS.textContent = 0;
                        SPAN_HOURS.textContent = 0;
                        SPAN_MINUTES.textContent = 0;
                        SPAN_SECONDS.textContent = 0;
                    
                    }
                  }//when the count end	
                  if(DURATIONEND <= 0)
                  {
                      $("#txtTitle").html("Finished sales");
                      toChangeCount=3;
                      document.getElementById("sCode").disabled=true;
                      SPAN_DAYS.textContent = 0;
                      SPAN_HOURS.textContent = 0;
                      SPAN_MINUTES.textContent = 0;
                      SPAN_SECONDS.textContent = 0;
                  }


              }
        updateCountdown();//call function for seconds
        setInterval(updateCountdown, MILLISECONDS_OF_A_SECOND);
      
      }else{
      
        if(h==999){
        	document.getElementById("sCode").disabled=false;
             SPAN_DAYS.textContent = 0;
             SPAN_HOURS.textContent = 00;
             SPAN_MINUTES.textContent = 00;
             SPAN_SECONDS.textContent = 00;
        }else{
            $("#txtTitle").html("Finished sales:");
            //toChangeCount=3;
        	document.getElementById("sCode").disabled=true;
            SPAN_DAYS.textContent = 0;
            SPAN_HOURS.textContent = 00;
            SPAN_MINUTES.textContent = 00;
            SPAN_SECONDS.textContent = 00;
        }
      
      
      }        
	   
});

//block enter
window.addEventListener("keypress", function(event){
    if (event.keyCode == 13){
        event.preventDefault();
    }
}, false);
   

//when fill the vipcode field, to validate the vipCode
function goToCollection()
{

  var vipCode = $("#vipCode").val();

  if(vipCode == "XE935Y")
  {
    sessionStorage.setItem("Whosalecode", 1);
      //var vipCode = sessionStorage.getItem('Whosalecode');
    //console.log(vipCode)
    window.location.href= "https://www.mikoleon.com/pages/miko-marketplace";
  }else{
    swal("Wholesale code incorrect!", "Please try again", "error");
  }


}